import { IntegrationRouteParams } from './appRoutes'
import { createRoute, createSubRoute, withSubRoutes } from './routeUtils'
import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

const createStoreRoutes = () => {
  const baseRoute =
    createRoute<typeof IntegrationType, IntegrationRouteParams>({
      integration: IntegrationType,
      accountId: null
    })`/${'integration'}/${'accountId'}`

  return {
    ...baseRoute,
    products: createSubRoute(baseRoute, '/products'),
    orders: createSubRoute(baseRoute, '/orders'),
    import: createSubRoute(baseRoute, '/import'),
    syncLogs: createSubRoute(baseRoute, '/syncLogs'),
    settings: withSubRoutes(
      createSubRoute(baseRoute, '/settings'),
      'api', 'company', 'orders', 'warehouses', 'returns', 'commissions', 'prices', 'supplies'),
    print: withSubRoutes(
      createSubRoute(baseRoute, '/print'),
      'labels', 'files', 'feeds')
  } as const
}

export const storeRoutes = {
  /**
   * NOTE: Also matches {@link moySkladRoutes.MoySkladOld} routes. Should mostly be used through subroutes.
   */
  Store: createStoreRoutes()
} as const